export default __webpack_public_path__ + "static/media/xrp.89fbb38c.png";